import React from "react";
import {
  IModalManagerContext,
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalManager,
  ModalTitle,
} from "src/components/Modal";
import Button from "@asphalt-react/button";
import { useTranslation } from "src/hooks/useTranslation";

export interface ErrorModalProps extends IModalManagerContext {
  onClick?: () => void;
}

export const ErrorModal = (props: ErrorModalProps) => {
  const translate = useTranslation();

  const errorTitleText = translate("passport_generic.server_error.title");

  const errorMessageText = translate("passport_generic.server_error.message");

  const errorCtaText = translate("passport_generic.server_error.cta");

  return (
    <ModalManager modalSize="m" {...props}>
      <Modal fitWidth>
        <ModalHeader>
          <ModalTitle>{errorTitleText}</ModalTitle>
        </ModalHeader>
        <ModalContent>{errorMessageText}</ModalContent>
        <ModalFooter>
          <Button onClick={() => props.onClick?.()}>{errorCtaText}</Button>
        </ModalFooter>
      </Modal>
    </ModalManager>
  );
};
